<div
  id="tiles-container"
  [ngClass]="
    (platformService?.isTouchExperience$ | async)
      ? platformService?.platformType === platformService?.platformEnum?.tablet
        ? 'tablet'
        : 'mobile'
      : 'desktop'
  "
>
  <div
    *ngIf="(platformService?.isTouchExperience$ | async) === false"
    class="tiles-swiper-button-prev"
    [ngClass]="
      homeSwiperRef?.swiper?.isBeginning ? 'swiper-button-disabled' : ''
    "
    (click)="homeSwiperRef?.swiper?.slidePrev()"
  ></div>
  <swiper-container
    #homeSwiperRef
    class="tiles-swiper-container"
    (init)="setSwiperInstance($event.detail[0])"
    data-cy="tile-swiper"
    navigation="true"
    navigation-prev-el=".tiles-swiper-button-prev"
    navigation-next-el=".tiles-swiper-button-next"
    slides-per-view="auto"
    [attr.space-between]="isMobile ? 8 : 16"
    observer="true"
    observe-parents="true"
  >
    <swiper-slide class="tile-slide" *ngFor="let tile of tiles">
      <app-base-tile
        [type]="tile.type"
        [id]="tile.id"
        [title]="tile.title"
        [newsTitle]="tile.newsTitle"
        [textBody]="tile.textBody"
        [newsBody]="tile.newsBody"
        [textButton]="tile.textButton"
        [newsButton]="tile.newsButton"
        [backgroundImage]="tile.backgroundImage"
        [path]="tile.path"
        [newsUrl]="tile.newsUrl"
        [deliveryDate]="tile.deliveryDate"
        [deliveryTime]="tile.deliveryTime"
        [dtDescription]="tile.dtDescription"
        [isDelivered]="tile.isDelivered"
        [lists]="tile.lists"
        [listsData]="listsData"
        [recommendedContent]="tile.recommendedContent"
        [customerTimeZone]="customerTimeZone"
        [totalAnnualSavings]="totalAnnualSavings"
        [hideEtaRange]="tile.hideEtaRange"
        [confirmedDeliveryDate]="tile.confirmedDeliveryDate"
        [etaReasonShort]="tile.etaReasonShort"
        [etaReasonLong]="tile.etaReasonLong"
        [isWmtTimezoneFeatureFlag]="isWmtTimezoneFeatureFlag"
      >
      </app-base-tile>
    </swiper-slide>
  </swiper-container>
  <div
    *ngIf="(platformService?.isTouchExperience$ | async) === false"
    class="tiles-swiper-button-next"
    [ngClass]="homeSwiperRef?.swiper?.isEnd ? 'swiper-button-disabled' : ''"
    (click)="homeSwiperRef?.swiper?.slideNext()"
  ></div>
</div>
